import { FieldRequirement } from "../components/FieldRequirement";
import { AdultConfirmation } from "./AdultConfirmation";
import { useLocale } from "../i18n";

export function FirstLoginProfile({ name, onName, adultConfirmed, onAdultConfirmed, disabled }: {
  name: string; onName: (value: string) => void; adultConfirmed: boolean; onAdultConfirmed: (value: boolean) => void; disabled: boolean;
}) {
  const { w } = useLocale();
  return <>
    <label htmlFor="first-login-name"><span className="field-caption">{w("الاسم", "Name")}<FieldRequirement required={true} /></span></label>
    <input id="first-login-name" autoComplete="name" value={name} onChange={e => onName(e.target.value)} required maxLength={25} disabled={disabled} />
    <AdultConfirmation id="first-login-adult" checked={adultConfirmed} onChange={onAdultConfirmed} disabled={disabled} />
  </>;
}
